module.exports = __webpack_public_path__ + "static/media/tech-image_two.3b943f4d.png";